import _ from "lodash";

export const addTestDirectory = (state, action) => {
  let list = state.list;
  const savedTestDirectory = action.payload;

  return [savedTestDirectory, ...list];
};

export const updateTestDirectory = (state, action) => {
  let list = state.list;
  const updatedTestDirectory = action.payload;

  const index = _.findIndex(list, ["id", updatedTestDirectory.id]);
  list[index] = updatedTestDirectory;

  return [...list];
};

export const removeTestDirectory = (state, action) => {
  let list = state.list;
  const deletedTestDirectory = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedTestDirectory.id;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};
